export const platform = {
  routes: [
    {
      path: "/question-set",
      component: () => import("../account-question-set"),
    },
    {
      path: "/question-set/answering/:id",
      component: () => import("../account-question-set-answering"),
    },
  ],
};
export const management = {
  routes: [
    {
      path: "/management/question",
      component: () => import("../management-question-view"),
    },
    {
      path: "/management/question-set",
      component: () => import("../management-question-set-view"),
    },
    {
      path: "/management/question-set/create",
      component: () => import("../management-question-set-detail"),
    },
    {
      path: "/management/question-set/:id",
      component: () => import("../management-question-set-detail"),
    },
  ],
};
export const workspace = {
  routes: [
    {
      path: "/workspace/library/question",
      component: () => import("../workspace-question-view"),
    },
    {
      path: "/workspace/library/question-set",
      component: () => import("../workspace-question-set-view"),
    },
    {
      path: "/workspace/library/question-set/create",
      component: () => import("../workspace-question-set-detail"),
    },
    {
      path: "/workspace/library/question-set/:id",
      component: () => import("../workspace-question-set-detail"),
    },
  ],
};

// TKP-147 / tasarım s.35 md.5,7 (s.20 md.4): ekran kalktı; eski adres panelin açılış sayfasına yönlenir. Backend, veri ve raporlar yerinde.
export const organization = {
  routes: [
    { path: "/organization/question-set", redirect: "/organization" },
    { path: "/organization/question-set/answering/:id", redirect: "/organization" },
  ],
};
export const gdpr = {
  routes: [
    { path: "/gdpr/question-set", redirect: "/gdpr/entities" },
    { path: "/gdpr/question-set/answering/:id", redirect: "/gdpr/entities" },
  ],
};
export const kvkk = {
  routes: [
    { path: "/kvkk/question-set", redirect: "/kvkk/entities" },
    { path: "/kvkk/question-set/answering/:id", redirect: "/kvkk/entities" },
  ],
};
export const ddo = {
  routes: [
    { path: "/ddo/question-set", redirect: "/ddo/roadmap" },
    { path: "/ddo/question-set/answering/:id", redirect: "/ddo/roadmap" },
  ],
};
export const bgys = {
  routes: [
    { path: "/bgys/question-set", redirect: "/bgys/roadmap" },
    { path: "/bgys/question-set/answering/:id", redirect: "/bgys/roadmap" },
  ],
};
